import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
//import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import VueMaskedInput from 'vue-masked-input'
import "@/design/index.scss";
import VueTimeago from 'vue-timeago'
import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
/////////////////// AG GRID
import {AgGridVue} from "ag-grid-vue";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import { MonthPicker } from 'vue-month-picker'
import { MonthPickerInput } from 'vue-month-picker'
//////handson
import { HotTable } from '@handsontable/vue';
//import { registerAllModules } from 'handsontable/registry';
import 'handsontable/dist/handsontable.full.css';
import { registerCellType, DropdownCellType ,NumericCellType ,AutocompleteCellType} from 'handsontable/cellTypes';
import { registerPlugin, ContextMenu,CopyPaste ,AutoColumnSize } from 'handsontable/plugins';
import { registerValidator, numericValidator } from 'handsontable/validators';
registerValidator(numericValidator);
registerPlugin(AutoColumnSize);
registerPlugin(ContextMenu);
registerPlugin(CopyPaste);
registerCellType(DropdownCellType);
registerCellType(NumericCellType);
registerCellType(AutocompleteCellType);

//registerAllModules();
Vue.use(HotTable)
Vue.component('hot-table',HotTable )
///////
Vue.use(MonthPicker)
Vue.use(MonthPickerInput)

Vue.use(VueToast);
Vue.use(VueApexCharts)

Vue.use(VueTimeago, {
    name: 'Timeago', // Component name, `Timeago` by default
    locale: 'es', // Default locale

})

import store from '@/state/store'

import App from './App.vue'

//import { initFirebaseBackend } from './authUtils'
import i18n from './i18n'

//import { configureFakeBackend } from './helpers/fake-backend';

import tinymce from 'vue-tinymce-editor'
/////////CUSTOM ///////////////

import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import pdf from 'vue-pdf'
Vue.use(VueGoodTablePlugin);

import axios from 'axios'
import VueAxios from 'vue-axios'
import Permissions from "./config/Permissions";
import Helper from "./config/Helper";


import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
/*Vue.directive('tooltip', VTooltip.VTooltip)
Vue.directive('close-popover', VTooltip.VClosePopover)
Vue.component('v-popover', VTooltip.VPopover)*/
Vue.component('masked-input', VueMaskedInput)
//
Vue.component('ag-grid-vue',AgGridVue)
Vue.component('month-picker',MonthPicker )
Vue.component('month-picker-input',MonthPickerInput )



Vue.mixin(Permissions);
Vue.mixin(Helper);
Vue.use(VueAxios, axios);

import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

import 'vue-select/dist/vue-select.css';

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, {
  moment,
})

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

Vue.component('masked-input', VueMaskedInput)
////////////////////////////////


Vue.component('tinymce', tinymce)
Vue.component('pdf',pdf)

/*const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}*/

Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
/*Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})*/
Vue.component('apexchart', VueApexCharts)
///////
axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('jwt');
  config.headers.Authorization = "Bearer " + token;
  return config;
});

const UNAUTHORIZED = 401;
axios.interceptors.response.use(
    response => response,
    error => {
      const {status} = error.response;
      if (status === UNAUTHORIZED) {
          localStorage.clear();
          router.push({ path: '/login' })
      }
      return Promise.reject(error);
    }
);

/////////
///
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')


